import { z } from "zod/v4";
import { sourceHealthSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

// GET /bis/sources — per-federation scrape freshness for the records transparency
// panel. No params; the analyst sees every source at once.
export const sources = {
	list: () => fetchApi("/sources", z.array(sourceHealthSchema)),
};
